/* istanbul ignore file */
import React from 'react';
import { DropDownFilter } from 'framework/list';
import { Dropdown } from 'framework/form';
import { EXPENSE_SUBTYPES, EXPENSE_TYPES_OPTIONS } from 'domain/shared/expense';

const DROPDOWN_OPTIONS = Object.entries(EXPENSE_SUBTYPES).reduce(
  (acc: { value?: string; label: string }[], [key, options]) => {
    acc.push(
      {
        label: EXPENSE_TYPES_OPTIONS[key],
      },
      ...Object.entries(options).map(([value, label]) => ({
        value,
        label,
      })),
    );

    return acc;
  },
  [],
);

const ExpensesSubTypeDropdownFilter = (props: any) => {
  return (
    <DropDownFilter {...props}>
      <Dropdown options={DROPDOWN_OPTIONS || []} {...props} />
    </DropDownFilter>
  );
};

export default ExpensesSubTypeDropdownFilter;
